import { Component, OnInit, Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionService } from 'src/app/shared/services/session.service';
import { MembershipService } from '../../../services/membership.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MembershipCustomerList } from '../../../models/membership-customer-list';
import { MembershipPlanList } from '../../../models/membership-plan-list';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { MembershipCustomerListQueryFilter } from '../../../memberships/membership-customer-list/membership-customer-list-query-filter';

@Component({
  selector: 'membership-customer-edit-modal',
  templateUrl: './membership-customer-edit-modal.component.html',
  styleUrl: './membership-customer-edit-modal.component.scss',
  standalone: false,
})
export class MembershipCustomerEditModalComponent extends BaseModalComponent implements OnInit {
  @Input() isRenewal: boolean = false;
  @Input() title: string;
  
  membershipCustomerForm: FormGroup;
  membershipPlans: MembershipPlanList[] = [];
  filter: MembershipCustomerListQueryFilter = new MembershipCustomerListQueryFilter();
  isLoading = false;

  constructor(
    private fb: FormBuilder, 
    private sessionService: SessionService,
    private membershipService: MembershipService,
    public dialogRef: MatDialogRef<MembershipCustomerEditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MembershipCustomerList
  ) {
    super();
  }

  ngOnInit(): void {
    this.filter.organizationId = this.sessionService.getUser()?.organizationId || null;
    this.membershipCustomerForm = this.fb.group({
      id: [this.data.id, Validators.required],
      firstName: [this.data.firstName, Validators.required],
      lastName: [this.data.lastName, Validators.required],
      emailAddress: [this.data.emailAddress, [Validators.required, Validators.email]],
      membershipPlanId: [this.data.membershipPlanId, Validators.required]
    });
    this.loadMembershipPlans();
  }

  loadMembershipPlans() {
    this.isLoading = true;
    this.membershipService.getAllPlansByOrganization(this.filter).subscribe({
      next: (result: any) => {
        this.membershipPlans = result.results || result;
        this.isLoading = false;
      },
      error: (error: any) => {
        this.isLoading = false;
        console.error(error);
      }
    });
  }

  onSubmit() {
    if (this.membershipCustomerForm.valid && this.filter.organizationId) {
      this.isLoading = true;
      const formValue = {
        ...this.membershipCustomerForm.value,
        stripeCustomerId: this.data.stripeCustomerId,
        stripeSubscriptionId: this.data.stripeSubscriptionId,
        discountCode: this.data.discountCode,
        organizationId: this.filter.organizationId,
        lastEditedBy: this.sessionService.getUserId(),
        startDate: this.data.startDate,
        endDate: this.data.endDate
      };

      if(this.isRenewal){
        formValue.isCanceled = false;
        formValue.cancelAt = null;
        this.membershipService.renewCustomer(formValue).subscribe({
          next: (result) => {
            this.dialogRef.close("save");
          },
          error: (error) => {
            console.error('Error renewing membership customer:', error);
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      }else{
        this.membershipService.updateCustomer(formValue.id, formValue).subscribe({
          next: (result) => {
            this.dialogRef.close("save");
          },
          error: (error) => {
            console.error('Error updating membership customer:', error);
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      }
      

    }
  }

  cancel() {
    this.dialogRef.close('cancel');
  }
}
